module.exports = __webpack_public_path__ + "img/dakaqiandao.dec0f6f0.png";